import Grid from "@material-ui/core/Grid/Grid";
import React, { PureComponent } from "react";

const heading = { textAlign: "center", marginBottom: 5, marginTop: 5 };

export default class Script extends PureComponent {
  render() {
    const {
      selectedRecording: { script, sample_link },
    } = this.props;

    return (
      <Grid container direction="row">
        <Grid item xs={12}>
          <h2 style={heading}>Script</h2>
        </Grid>
        <Grid item xs={12}>
          <p>{script}</p>
        </Grid>
        <Grid item xs={12}>
          <h2 style={heading}>Audio Sample</h2>
        </Grid>
        <Grid item xs={12}>
          <audio
            style={{ width: "97%" }}
            controls="controls"
            src={sample_link}
            controlsList="nodownload"
          />
        </Grid>
      </Grid>
    );
  }
}
